import IqosNova from './IqosCocktails';
export default IqosNova;
